/* The picked options of a choice answer, one chip each. Neutral on purpose: a fill in the chip
 * surface with primary ink. No accent, no tint — nothing here is an action or an alert, and the
 * accent is a scalpel. The hairline is what keeps the chip visible on the dark card, where the
 * chip fill sits only a step above the ground. */

.list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
  min-width: 0;
}

.chip {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: var(--h-survey-choice);
  padding: var(--space-0) var(--space-2);
  border-radius: var(--r-pill);
  background: var(--bg-chip);
  border: var(--border-hairline) solid var(--border-2);
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  line-height: var(--type-label-lh);
  color: var(--text);
  white-space: nowrap;
}
